module.exports = __webpack_public_path__ + "img/guests.8a9f9490.svg";